module.exports = __webpack_public_path__ + "9b9bee13c67ab85cd468d1c5fe38ad3e.svg";